<div class="flex flex-col gap-2">
  <button
    type="button"
    class="flex items-center justify-between gap-3"
    [class]="disabled() ? 'opacity-60 cursor-not-allowed' : ''"
    (click)="toggle()">
    <h3 class="m-0" [class]="titleClass()">{{ title() }}</h3>
    <div class="flex items-center gap-2 shrink-0">
      <ng-content select="[accordionHeaderExtra]" />
      @if (badge() || badgeIcon()) {
        <div [class]="badgeClass()">
          @if (badgeIcon()) {
            <svg-icon
              [src]="badgeIcon()!"
              svgClass="w-3 h-3"
              aria-hidden="true" />
          } @else {
            <span>{{ badge() }}</span>
          }
        </div>
      }
      <svg-icon
        class="transform text-primary transition-transform duration-200"
        [class.rotate-180]="open()"
        src="assets/svg/arrow.svg"
        svgClass="w-[1.625rem] h-6" />
    </div>
  </button>

  @if (open()) {
    <div class="text-secondary text-sm leading-5">
      <ng-content />
    </div>
  }
</div>
